import React,{ useEffect, useState } from 'react';
import {Toast,Page } from 'react-weui';
import { getAreaList } from '@/services/home';
import styles from './styles.scss';
import Empty from '@/components/empty';
import { history } from 'umi';


export default (props) => {

  const [dataList,setDataList] = useState([]);

  useEffect(() => {

    getAreaList({parentCode:0}).then(res => {

      if (res && res.code == 200) {
        setDataList(res.data);
      }
    });
  },[]);


  return(
    <Page transition={true} infiniteLoader={false} ptr={false}>

      {dataList.length ? dataList.map(item => (
        <div className={styles.area_item} key={item.id} onClick={()=> {
          history.push({pathname:'/home/store/selectCity',state:{area:item}});
        }}>
          <label>{item.areaName}</label>
          <img src={require('@/assets/arrows.png')}/>
        </div>
      )) : <Empty text={'暂无数据'}/>}

    </Page>
  )
}
